import bankCodes from '@/languages/ko-kr/bank-codes'
import enablingStatus from '../enabling-status'

export default {
  'count': '@:terms.count',
  'KRW': '@:terms.currency',
  'transfer': '@:terms.transfer',
  'payment': '@:terms.payment',
  'need': '@:terms.need',
  'bank': '@:terms.bank',
  'subsidy-lookup': '@:terms.subsidy @:terms.lookup',
  'service': {
    'tax': '@:terms.tax 납부',
    'invoice': '@:terms.invoice',
    'hidden-subsidy': '@:terms.hidden-subsidy',
    'cert-center': '@:terms.enabling @:terms.management',
    'taxrefund': '@:pages.taxrefund.title',
  },
  'institution': {
    'giro': '@:terms.giro',
    'hometax': '@:terms.hometax',
    'ei': '@:terms.ei',
    'bank': '@:terms.bank',
    ...bankCodes,
  },
  'status': {
    ...enablingStatus,
  },
  'empty-cert': {
    'pending': '@:terms.certificate를 @:terms.register해주세요',
    'processing': '@:terms.certificate를 @:terms.register중입니다',
    'expired': '@:terms.certificate를 @:terms.register해주세요',
    'failure': '@:terms.certificate를 @:terms.register해주세요'
  },
  'error': {
    'get-cert-institutions': '@:terms.enabling된 기관 목록을 불러오는데 실패하였습니다.',
    'get-invoice-summary': '@:terms.purchase-invoice 정보를 불러오는데 실패하였습니다.',
    'get-tax-summary': '@:terms.tax 정보를 불러오는데 실패하였습니다.',
  },
  'taxrefund': {
    'amount': '@:pages.taxrefund.amount',
    'before-analysis': '@:pages.taxrefund.suggest.before-analysis',
    'analyzing': '@:pages.taxrefund.analyzing',
    'before-confirm': '@:pages.taxrefund.suggest.before-confirm',
  }
}
